import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { Datalayer, getAnalytics } from '@miro-site/analytics';

function sendAccountPickerShownEvent() {
  return _sendAccountPickerShownEvent.apply(this, arguments);
}

function _sendAccountPickerShownEvent() {
  _sendAccountPickerShownEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var analytics;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            analytics = getAnalytics();
            _context.next = 4;
            return analytics.sendEvent(new Datalayer('accountPickerShown', {
              openedFrom: 'templates'
            }));

          case 4:
            _context.next = 9;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.error(_context.t0);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _sendAccountPickerShownEvent.apply(this, arguments);
}

function sendAccountSelectedInAccountPickerEvent(_x, _x2) {
  return _sendAccountSelectedInAccountPickerEvent.apply(this, arguments);
}

function _sendAccountSelectedInAccountPickerEvent() {
  _sendAccountSelectedInAccountPickerEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref, callback) {
    var accountId, accountsListIndex, workspaceKey, analytics;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accountId = _ref.accountId, accountsListIndex = _ref.accountsListIndex, workspaceKey = _ref.workspaceKey;
            _context2.prev = 1;
            analytics = getAnalytics();
            _context2.next = 5;
            return analytics.sendEvent(new Datalayer('accountPickerAccountSelected', {
              accountsListIndex: accountsListIndex,
              accountId: accountId,
              workspaceKey: workspaceKey
            }));

          case 5:
            if (callback) {
              callback();
            }

            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            // eslint-disable-next-line no-console
            console.error(_context2.t0);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _sendAccountSelectedInAccountPickerEvent.apply(this, arguments);
}

export function useAccountPicker(_ref2) {
  var onAccountLoaded = _ref2.onAccountLoaded,
      onAccountSubmited = _ref2.onAccountSubmited,
      onAccountCancel = _ref2.onAccountCancel,
      onAccountError = _ref2.onAccountError;

  var _useState = useState(false),
      isAccountPickerVisible = _useState[0],
      setAccountPickerVisible = _useState[1];

  useEffect(function () {
    if (isAccountPickerVisible) {
      sendAccountPickerShownEvent();
    }
  }, [isAccountPickerVisible]);

  var onAccountPickerLoaded = function onAccountPickerLoaded(accountsIds, workspaceKey) {
    if (!Array.isArray(accountsIds)) {
      return;
    }

    var accountsLength = accountsIds.length;

    switch (accountsLength) {
      //in application user will use account creation flow
      case 0:
        onAccountLoaded(undefined, workspaceKey);
        break;
      //copy board to single account. no need to select

      case 1:
        onAccountLoaded(accountsIds[0], workspaceKey);
        break;
      //user will select account to copy board

      default:
        setAccountPickerVisible(true);
        break;
    }
  };

  var onAccountPickerSubmit = function onAccountPickerSubmit(accountId, accountsListIndex, workspaceKey) {
    sendAccountSelectedInAccountPickerEvent({
      accountId: accountId,
      accountsListIndex: accountsListIndex,
      workspaceKey: workspaceKey
    }, function () {
      onAccountSubmited(accountId, workspaceKey);
    });
  };

  var onAccountPickerCancel = function onAccountPickerCancel() {
    onAccountCancel();
    setAccountPickerVisible(false);
  };

  return [isAccountPickerVisible, onAccountPickerLoaded, onAccountPickerSubmit, onAccountPickerCancel, onAccountError];
}